/**
 * Layout constants shared by the plan grid and the cards inside it.
 *
 * ── WHY A RAW MEDIA QUERY AND NOT A THEME BREAKPOINT ────────────────────────
 * The plan layout is specified at 768px: at or above it the three paid plans
 * are one row of three and Basic is a full-width row beneath them; below it
 * everything stacks. MUI's default breakpoints are 600 (sm) and 900 (md), and
 * 768 is between them — so `md` would keep the three cards stacked on a 800px
 * tablet that the spec says should show them side by side, and `sm` would try
 * to fit three plan cards into 600px.
 *
 * Widening the theme's breakpoints instead would move every other `sm`/`md` in
 * the app to serve this one screen. So the number lives here, once — an sx key
 * of `[PLANS_WIDE_UP]` is a plain media query, which MUI passes straight
 * through to emotion.
 *
 * Only the PAGE grid reads it. The cards inside arrange themselves by their
 * own width instead (container queries in BasicPlanCard, auto-fit columns in
 * PlanFeatureList), because Dashboard's sidebar is a fixed 256px: a viewport
 * breakpoint says nothing reliable about how much room a card actually has.
 */
export const PLANS_WIDE_MIN_PX = 768;

/** sx key: styles that apply once the plan row is wide enough to be a row. */
export const PLANS_WIDE_UP = `@media (min-width:${PLANS_WIDE_MIN_PX}px)`;
